import React, { useState, useContext, useEffect, useRef, Fragment } from "react";
import "../../../ui-styles/cards/Prescription.css";
import "../../../ui-styles/sliders/RightFullSlider.css";
import "../../../ui-styles/buttons/IconButton.css";
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../ui-styles/cards/Prescription.css";
import "../../../ui-styles/prescription/prescriptionAdd.css"
import "../../../ui-styles/sliders/RightChildSlider.css";
import "../../common/fileUploads/uploadsStyles.css";
import "../../../ui-styles/tooltips/tooltips.css";
import { dateFormat, getAge, getExperience } from "../../../lib/functions";
import { LangCtx, RoleCtx, CustomCtx, InstavcCtx, PayLoadCtx } from "../../../lib/context";
// import axios from "axios";
import PrescriptionModal from "./PrescriptionModal";
import DeletePrescModal from "./DeletePrescModal";
import DrugRow from "./DrugRow";
// import UploadPrescriptionModal from "./UploadPrescriptionModal";
import { getPrescription, createPrescription, updatePrescription, prescriptiondelete } from "../../../actions/schedule";
import Loader from "../../../lib/ui/loader/Loader";
import { getDoctorSignature, scan } from "../../../actions/appointment";
// import { OffLineAPI } from '../../../offline-auth/api';
// import config from '../../../config.json';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
// import { Document, Page, pdfjs } from 'react-pdf';
import NewPrescription from "./newPrescription";
import { Storage } from "aws-amplify";
import Button from "../../../lib/ui/buttons/Button";
import { getUserDetails } from "../../../actions/users";
import NoData from "../../../lib/ui/nodata/NoData";
// import { getDegree, getDepartmentList, getSpecialization } from "../../../actions/configuration";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
// import PdfView from "../../common/fileUploads/components/pdfView";
import { Document, Page } from "react-pdf/dist/entry.webpack";
import { toast } from "react-toastify";


// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const PrescriptionSlide = (props) => {
    console.log("kafakf",props)
    const { l } = useContext(LangCtx);
    const { custom } = useContext(CustomCtx);
    const { type } = props;
    const { doctorData } = props.data;
    const [patientData, setPatient] = useState({});
    const { role } = useContext(RoleCtx);
    const [uploadedData, setUploadedData] = useState(null);
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [prescription, setPrescription] = useState(null);
    // const [modalUpload, setModalUpload] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    // const [cUrl, setCUrl] = useState('');
    const contentRef = useRef();
    const instavcCtx = useContext(InstavcCtx);
    const { instaVC } = instavcCtx !== null ? instavcCtx : { instaVC: undefined };
    const { payload } = useContext(PayLoadCtx);


    const backgroundColor = {
        backgroundColor: '#24a4c4'
    }
    // backgroundColor: '#2b80c4'
    const footerColor = {
        backgroundColor: '#24a4c4'
    }

    const id = useRef(null);

    const loadPresciption = () => {
        setLoading(true);
        if (type === "view" || type === "past") {
            getUserDetails(props.data.patientId).then(res => {
                setPatient(res.data);
            }).catch(err => {
                console.log("err ==== ", err);
            })
        }
        else {
            setPatient(props.data.patientData)
        }
        getPrescription(props.data.appointmentId).then(res => {
            if (res.status) {
                setPrescription(res.data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            console.log("err ==== ", err);
        })
    }

    // useEffect(()=>{

    //     const fetchdata = async () => {
    //         if(!(prescription && prescription?.prescriptionpath?.type === "image/png" || prescription?.prescriptionpath?.type === "image/jpeg" || prescription?.prescriptionpath?.type === "image/jpg" || prescription?.prescriptionpath?.type === "image/x-png")){
    //            const u8array =  await uni8Array(prescription?.prescriptionpath?.url, prescription?.prescriptionpath?.type)
    //            console.log("uni8Array=======================>", u8array)
    //            setCUrl(u8array);
    //         }
    //     }

    //     fetchdata()
    // },[prescription])

    // const uni8Array = async(file, type) => {

    //     try {
    //         // const response = await fetch(file); // Replace with your URL
    //         // const blob = await response.blob();
    //         // const url = URL.createObjectURL(blob);
    //         // setBlobUrl(url);
    //         const response = await fetch(file); // Replace with your S3 URL
    //         const arrayBuffer = await response.arrayBuffer();
    //         const uint8Array = new Uint8Array(arrayBuffer);
    //         return uint8Array;
    //       } catch (error) {
    //         console.error('Error fetching URL:', error);
    //       }
    // }


    useEffect(() => {
        if (props.data.appointmentId && id.current !== props.data.appointmentId) {
            id.current = props.data.appointmentId;
            setLoading(true);
            loadPresciption();
        }
    }, [props.data, loadPresciption])

    useEffect(() => {
        setLoading(true);
        getDoctorSignature(props.data.doctorId).then(res => {
            if (res.status) {
                setUploadedData(res.data)
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            console.log("err ==== ", err);
        })

    }, []);


    // const processMessage = useCallback((message) => {
    //     let _msg = message.message;
    //     switch (_msg.message) {
    //         case 'PRESCRIPTION':
    //             loadPresciption();
    //             break;
    //         default: return;
    //     }
    // }, [])

    // useEffect(() => {
    //     // if (instaVC) {
    //     //     // instaVC.on('message-received', processMessage);
    //     //     return function cleanup() {
    //     //         // instaVC.off('message-received');
    //     //     }
    //     // }
    // }, [instaVC]);

    const handleModal = () => {
        setModal(prevState => !prevState);
    }

    // const handleModalUpload = () => {
    //     setModalUpload(prevState => !prevState);
    // }

    const handleDeleteModal = (e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        setOpenDelete(prevState => !prevState);
    }

    const syncCommand = (message, body, cmd = 'CMD') => {
        const _txtCommand = {
            message: message,
            senderName: payload && payload.firstName ? payload.firstName : '',
            senderEmail: 'email',
            userId: payload && payload.userId ? payload.userId : '',
            messageType: cmd,
            data: body
        }
        instaVC.sendMessageToRoom(_txtCommand);
    }

    const createOrEditPrescription = (body) => {
        setLoading(true);
        body.clinicId = props.data.clinicId;
        body.doctorId = props.data.doctorId;
        body.patientId = props.data.patientId;

        if (prescription != null) {
            updatePrescription(props.data.appointmentId, body)
                .then((res) => {
                    setLoading(false);
                    if (res && res.status) {
                        loadPresciption()
                        syncCommand("PRESCRIPTION", null);
                        // handleModal()
                    }
                }).catch(err => {
                    setLoading(false);
                    console.log(err.response)
                })
        } else {
            body.appointmentId = props.data.appointmentId;
            createPrescription(body)
                .then((res) => {
                    setLoading(false);
                    if (res && res.status) {
                        loadPresciption()
                        syncCommand("PRESCRIPTION", null);
                        // handleModal()
                    }
                }).catch(err => {
                    setLoading(false);
                    console.log(err.response)

                })
        }
    }

    const handleDeletePrescription = () => {

        if (prescription.prescriptionpath && prescription.prescriptionpath.key) {
            const body = {
                key: prescription.prescriptionpath.key
            }
            Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_s3Region })
            Storage.remove(body.key).then((response) => {
                deletePrescription()
            }).catch(err => {
                setLoading(false);
                console.log("error ====", err);

            });
        }
        else {
            handleDeleteModal()
            deletePrescription()
        }
    }


    const deletePrescription = () => {
        setLoading(true)
        prescriptiondelete({ appointmentId: props.data.appointmentId })
            .then((res) => {
                setLoading(false);
                if (res && res.status) {
                    setPrescription();
                    setOpenDelete(false);
                    loadPresciption()
                    // handleDeleteModal()
                }
            }).catch(err => {
                setLoading(false);
                console.log(err.response)
            })
    }

    const uploadFile = async (e) => {
        setLoading(true);
        if (e.target.files.length > 0) {
            let file = e.target.files[0];
            let filename = new Date().valueOf() + file.name;
            // Storage.configure({ bucket: process.env.REACT_APP_s3,region:process.env.REACT_APP_CognitoRegion })

            const formData = new FormData();
            formData.append("file", file);

            let params = {
                bucket: process.env.REACT_APP_s3,
                fileName: 'prescription/' + filename,
                region: process.env.REACT_APP_s3Region
            }

            let s3UploadRes = await scan(formData, params);


            if (s3UploadRes && s3UploadRes.status) {
                s3UploadRes = s3UploadRes.data
                setLoading(false);

                const body = {
                    clinicId: props.data.clinicId,
                    doctorId: props.data.doctorId,
                    patientId: props.data.patientId,
                    appointmentId: props.data.appointmentId,
                    prescriptionpath: { key: s3UploadRes.key, url: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/` + s3UploadRes.key, type: file.type }
                }
                createPrescription(body)
                    .then((res) => {
                        setLoading(false);
                        if (res && res.status) {
                            loadPresciption()
                        }
                    }).catch(err => {
                        setLoading(false);
                        console.log(err.response)
                    })
            } else {
                console.log("s3UploadRes.........:)", s3UploadRes)
                toast.error(s3UploadRes.error, {
                    position: toast.POSITION.TOP_RIGHT,
                })
            }
            setLoading(false);
            // Storage.put('prescription' + '/' + filename,
            //     file,
            //     { contentType: file.type, customPrefix: { public: '' } })
            //     .then(result => {
            //         // console.log("result=====", result);


            //         const body = {
            //             clinicId: props.data.clinicId,
            //             doctorId: props.data.doctorId,
            //             patientId: props.data.patientId,
            //             appointmentId: props.data.appointmentId,
            //             prescriptionpath: { key: result.key, url: 'https://insta-consult.s3-ap-southeast-1.amazonaws.com' + '/' + result.key, type: file.type }
            //         }
            //         // console.log("body========", body);
            //         createPrescription(body)
            //             .then((res) => {
            //                 setLoading(false);
            //                 if (res && res.status) {
            //                     loadPresciption()
            //                 }
            //             }).catch(err => {
            //                 setLoading(false);
            //                 console.log(err.response)
            //             })


            //         // const formData = new FormData();
            //         // formData.append('fileData', file);
            //         // OffLineAPI.upload("api", "/uploadprescription", formData)
            //         //     .then(res => {
            //         //         const body = {
            //         //             clinicId: props.data.clinicId,
            //         //             doctorId: props.data.doctorId,
            //         //             patientId: props.data.patientId,
            //         //             appointmentId: props.data.appointmentId,
            //         //             prescriptionpath: { key: res.path, type: file.type }
            //         //         }
            //         //         createPrescription(body)
            //         //             .then((res) => {
            //         //                 setLoading(false);
            //         //                 if (res && res.status) {
            //         //                     loadPresciption()
            //         //                 }
            //         //             }).catch(err => {
            //         //                 setLoading(false);
            //         //                 console.log(err.response)
            //         //             })

            //         //     }).catch(err => {
            //         //         console.log("error ====", err);
            //         //         console.log("error ====", err.response);

            //         //     });
            //     })
        }

    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages)
    }

    const prevClick = () => {
        setPageNumber(prevState => prevState - 1)

    }

    const nextClick = () => {
        setPageNumber(prevState => prevState + 1)

    }
    let cls = props.openSlide 
  ? (props?.current === "PRC" ? "prescreptionVisitInfo rightSliderIn" : "rightFullSlider rightSliderIn")
  : (props?.current === "PRC" ? "prescreptionVisitInfo" : "rightFullSlider");
    cls += props.type !== "view" ? " fullSlide" : "";

    let header = null, footer = null, sign = null;

    for (let i in uploadedData) {
        let item = uploadedData[i];
        switch (item.uploadtype) {
            case "header": header = item;
                break;
            case "signature": sign = item;
                break;
            case "footer": footer = item;
                break;
            default: break;
        }
    }

    return (
        <>
            <div className={cls}>
                <div className={`${props.current==="PRC" ? "rightSliderHdrvisitInfo":"rightSliderHdr"}`}>
                    <div className="hdrRowBlock">
                        {props?.current != "PRC"?<div className="hdrTitleBox">
                            <span>{l.presc}</span>
                        </div>:""}
                        <div className="hdrActionGroup">
                            {prescription && prescription !== null ?

                                <div className="prescTitleAction">
                                    {role === "D" && type !== "view" && type !== "past" ? <div className="rowBlock noWidth">
                                        {!prescription.prescriptionpath &&
                                            <Button
                                                label={l.edit}
                                                size="sm"
                                                type="outLine"
                                                onClick={handleModal}
                                            />
                                        }
                                        <Button
                                            label={l.delete}
                                            size="sm"
                                            type="outLine"
                                            onClick={handleDeleteModal}
                                        />
                                        <div tooltip="Print" flow="down">
                                            <ReactToPrint content={() => contentRef.current}>
                                                <PrintContextConsumer>
                                                    {({ handlePrint }) => (
                                                        <div className="iconBtnBlock primary Sm ripple" onClick={handlePrint}>
                                                            <img src="/images/icons/printing.png" alt="icon" className="invertPrimary" />
                                                        </div>
                                                    )}
                                                </PrintContextConsumer>
                                            </ReactToPrint>
                                        </div>
                                    </div>
                                        : <div className="rowBlock noWidth">
                                            <div tooltip="Print" flow="down">
                                                <ReactToPrint content={() => contentRef.current}>
                                                    <PrintContextConsumer>
                                                        {({ handlePrint }) => (
                                                            <div className="iconBtnBlock primary Sm ripple" onClick={handlePrint}>
                                                                <img src="/images/icons/printing.png" alt="icon" className="invertPrimary" />
                                                            </div>
                                                        )}
                                                    </PrintContextConsumer>
                                                </ReactToPrint>
                                            </div>
                                        </div>}
                                </div> : null}
                            {props?.current != "PRC"?<div className="hdrActItem close" onClick={props.closePresc}></div>:""}
                        </div>
                    </div>
                </div>
                {console.log("debug",role,type)}
                <div className="printPrescWrapper">
                    <div className="printPrescContainer" ref={contentRef}>
                        {loading ? <Loader /> : prescription ?
                            prescription && prescription.prescriptionpath ?
                                loading ? <Loader /> :
                                    <Fragment>
                                        <div className="mediaBdyCntnr pdngTB16">
                                            <div className="mediaBdy">
                                                <div className="mediaViewBox">
                                                    <div className="mediaFileContainer">
                                                        {prescription && prescription.prescriptionpath && (prescription.prescriptionpath.type === "image/png" || prescription.prescriptionpath.type === "image/jpeg" || prescription.prescriptionpath.type === "image/jpg" || prescription.prescriptionpath.type === "image/x-png") ?

                                                            <img src={prescription.prescriptionpath.url} alt="prescriptionfile" /> :
                                                            <>
                                                                <Fragment>
                                                                    <nav className="pdfControls">
                                                                        {pageNumber > 1 && <button onClick={prevClick}>Prev</button>}
                                                                        {numPages && pageNumber < numPages && <button onClick={nextClick}>{l.next}</button>}
                                                                    </nav>
                                                                    <Document file={prescription.prescriptionpath.url} onLoadSuccess={onDocumentLoadSuccess}  >
                                                                        <Page pageNumber={pageNumber} />
                                                                        {/* {Array.apply(null, Array(numPages))
                                                                .map((x, i) => i + 1)
                                                                .map(page => <Page pageNumber={page}></Page>)} */}
                                                                    </Document>
                                                                    <div className="pdfControls">
                                                                        <p>Page {pageNumber} Page {numPages}</p>
                                                                    </div>
                                                                </Fragment>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="waterMarkLogoBlock">
                                                <div className="waterMarkLogo">
                                                    {/* <img src="/images/logos/inclinix-logo.png" alt="watermark logo" /> */}
                                                    <p>For software demo, not for use.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                :
                                <Fragment>
                                    <div className="printPrescBdy">
                                        {header ?
                                            <div className="prevPrescHdrBanner">
                                                <div className="prevPrescHdr">
                                                    <div className="prevPrescBranding prescHdFooter">
                                                        <img src={header.uploadurl} alt="logo" />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="presBranding" style={backgroundColor} >
                                                <img src={custom?.logo ? custom.logo : "/images/logos/inclinix-logo.png"} className={custom?.logo ? "" : "invertWhite"} alt="logo" />
                                            </div>
                                        }
                                        <div className="printPrescBdyContent">
                                            <span className="presTxtL txtCenter"><small>{prescription.prescriptionId}</small></span>
                                            <div className="prescDetailItem">

                                                <div className="presDtlBlock">
                                                    {/* <span className="presTxtL">{l.pat_name} <small>{patientData.firstName ? `${patientData.firstName} ` : ''}{patientData.lastName ? `${patientData.lastName}` : ''}</small></span> */}
                                                    {console.log("patientData",patientData)}
                                                    <span className="presTxtL">{l.pat_name} <small>{patientData.title ? patientData.title : ''}{patientData.firstName || patientData.lastName ? `${patientData.firstName} ${patientData.lastName}` : `${patientData.name}`}</small></span>
                                                    <span className="presTxtL">{l.pat_age} <small>{patientData.dob ? `${getAge(new Date(patientData.dob))}` : ''}</small></span>
                                                    <span className="presTxtL">{l.pat_gender} <small className="capitalizeTxt">{patientData.gender ? patientData.gender : ''}</small></span>
                                                    <span className="presTxtL">{l.upload_date} <small>{props.data.updatedAt ? dateFormat(props.data.updatedAt) : ''}</small></span>
                                                </div>
                                                    {console.log("type",type)}
                                                <div className="presDtlBlock txtRight">
                                                    <span className="presTxtL">{l.lic_no} <small>{(doctorData.licenses && doctorData.licenses.length) > 0 ? doctorData.licenses[0].licenseNo ? doctorData.licenses[0].licenseNo : '' : ''}</small></span>
                                                    {(type === "view" || type === "past" || props?.current==="PRC") ?
                                                        <span className="docLTxt">{`Dr. ${doctorData.name ? doctorData.name : ''}`}</span> :
                                                        <span className="docLTxt">{`Dr. ${doctorData.firstName ? `${doctorData.firstName} ` : ''}${doctorData.lastName ? `${doctorData.lastName}` : ''}`}</span>}
                                                    <span className="presTxtL">{doctorData.speciality ? doctorData.speciality : ''}<small></small></span>
                                                </div>
                                            </div>
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.reas_for_call}: <small>{props.data.reason ? l[props.data.reason] : ''}</small></span>
                                                    <span className="presTxtL">{l.det_by_pat} <small>{props.data.description ? decodeURIComponent(props.data.description) : ''}</small></span>
                                                </div>
                                            </div>
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.chief_comp}:</span>
                                                    <span className="presTxtL"><small>{prescription.chiefComplaint}</small></span>
                                                </div>
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.diagnosis}:</span>
                                                    <span className="presTxtL"><small>{l[prescription.diagnosis]}</small></span>
                                                </div>
                                            </div>
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.investigation}:</span>
                                                    <span className="presTxtL"><small>{prescription.investigation}</small></span>
                                                </div>
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.remarks}:</span>
                                                    <span className="presTxtL"><small>{prescription.remarks}</small></span>
                                                </div>
                                            </div>
                                            <div className="presMedGroup">
                                                <div className="prescTableWrapper">
                                                    <table className="prescTable">
                                                        <thead>
                                                            <tr>
                                                                <th>{l.s_no}</th>
                                                                <th>{l.drug_name}</th>
                                                                <th>{l.qtyd}</th>
                                                                <th>{l.schedule}</th>
                                                                <th>{l.note}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {prescription.drugs.map((drug, i) =>
                                                                <DrugRow data={drug} key={i} index={i} />
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="waterMarkLogoBlock">
                                            <div className="waterMarkLogo">
                                                {/* <img src="/images/logos/inclinix-logo.png" alt="watermark logo" /> */}
                                                <p>For software demo, not for use.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="printPrescFooter">
                                        <div className="signatureCol">
                                            <div className="signatureBox">
                                                {(type === "view" || type === "past" || props?.current ==="PRC") ? <span className="docLTxt">{`Dr. ${doctorData.name ? doctorData.name : ''}`}</span> :
                                                    <span className="docLTxt">{`Dr. ${doctorData.firstName ? `${doctorData.firstName} ` : ''}${doctorData.lastName ? `${doctorData.lastName}` : ''}`}</span>}
                                                <span className="docSTxt">{doctorData.qualification ? doctorData.qualification : ""}
                                                    {doctorData.department ? `(${doctorData.department})` : ''}{doctorData.serviceStartDate ? `- ${getExperience(new Date(doctorData.serviceStartDate))}` : ''}</span>
                                                <div className="signatureIcon">
                                                    {sign &&
                                                        <img src={sign.uploadurl} alt="logo" />}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="prevPrescFooter">
                                            {footer ?
                                                <div className="prevPrescBranding prescHdFooter">
                                                    <img src={footer.uploadurl} alt="logo" />
                                                </div>
                                                :
                                                <div className="prevPrescBranding prescHdFooter" style={footerColor}>
                                                    {/* <img src="/images/logos/presc-footer.png" alt="logo" /> */}
                                                    <p>Copyright © 2020-21 | Powered by Peoplelink Unified Communications Pvt. Ltd</p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Fragment>
                            :
                            (role === "D" && type !== "view" && type !== "past" ? <NewPrescription handleModal={handleModal} uploadFile={uploadFile} /> : <div className="prescriptionCard">
                                <div className="presCardBdy noPrescMsg">
                                    <NoData src="/images/icons/prescription-new.png" label={l.no_presc_txt} />
                                </div>
                            </div>)
                        }
                    </div>
                </div>


            </div>

            {modal && <PrescriptionModal open={modal} handleCreateOrEdit={createOrEditPrescription} closeModal={handleModal} data={prescription} current={props?.current} />}
            {openDelete && <DeletePrescModal openDelete={openDelete} handleDelete={handleDeletePrescription} closeDelete={(e) => handleDeleteModal(e)}/>}
            {/* {modalUpload && <UploadPrescriptionModal openUploadModal={modalUpload} closeUploadModal={handleModalUpload} />} */}
        </>
    )
}
export default PrescriptionSlide;